import { applyMiddleware, createStore, Middleware } from "redux";
import { createLogger } from "redux-logger";
import { createEpicMiddleware } from "redux-observable";
import dependencies, { Dependencies } from "./../services/index";
import rootEpic from "./rootEpic";
import rootReducer, { RootState } from "./rootReducer";
import { RootAction } from "./types.d";

const epicMiddleware = createEpicMiddleware<
  RootAction,
  RootAction,
  RootState,
  Dependencies
>({ dependencies });

export default function configureStore(preloadedState = {}) {
  const middlewares: Middleware[] = [epicMiddleware];

  if (process.env.NODE_ENV === "development") {
    const loggerMiddleware = createLogger({ level: "log" });
    middlewares.push(loggerMiddleware);
  }

  const middlewareEnhancer = applyMiddleware(...middlewares);

  const store = createStore(rootReducer, preloadedState, middlewareEnhancer);

  epicMiddleware.run(rootEpic);

  return store;
}
